// QUAL OFERTA ESTÁ NO AR na interface nova — o App grava a partir de
// /api/interface (paywall) e as telas de venda leem na hora de montar.
//   pago = o app pago com 7 dias grátis (01/11/2026, PAYWALL_DURO=1);
//   senão = o modelo de 31/10 (app grátis, trilhas pagas, 1ª etapa grátis).
let pago = false;
let dias = 7;
export const definirModelo = (p: boolean, d?: number | null) => { pago = !!p; if (d != null && d >= 0) dias = d; };
export const modeloPago = () => pago;
export const diasDoTeste = () => dias;
//   só assinantes (02/11/2026, noite) = pago sem teste (TESTE_DIAS=0), com a
//   garantia de 7 dias: o App grava a partir de /api/oferta (definirModelo(true, 0)).
export const soAssinantes = () => pago && dias === 0;
